import { DeviceSelector as PrestyledDeviceSelector } from '@streamr/tv-ui';
import styled from 'styled-components';
import { AbstractPopup } from '../AbstractPopup';
import { PopupCssPreset } from '../Popup.styles';
export const DeviceSelector = styled(PrestyledDeviceSelector) `
    max-width: none;
    min-width: 0;
    max-height: none;
    padding: 0;
`;
export const DeviceSelectorContainer = styled.div `
    max-height: calc(var(--vh-100, 100vh) - 2 * var(--Popup_BoundingBoxPadding, 1rem) - 3rem);
    padding: 0 1.5rem;
`;
export const DeviceSelectorPopupRoot = styled(AbstractPopup) `
    ${PopupCssPreset.Center};
    --Popup_Padding: 1.5rem 0;
    --Popup_Width: 20rem;

    @media (min-width: 30rem) {
        &.top-center {
            ${PopupCssPreset.AnchoredTopCenter};
        }

        &.bottom-center {
            ${PopupCssPreset.AnchoredBottomCenter};
        }
    }
`;
